soundTracker = {};

soundTracker.initialise = function(json, container) {
    soundTracker.container = container;
    container.background = resourceManager.createObject("graphics", "background", container.name);
    container.soundsText = resourceManager.createObject("text", "soundsText", container.name, {fontDefinition: json.fontDefinition, anchor: {x:0, y:0}, fontOverrides: {"align": "left", "fill": "#FFFFFF"}});

    container.update = function() {

        var text = "";
        var soundsPlaying = [];

        // Draw all sound names / ID's
        for (var i = 0; i < soundManager.playingSounds.length; i++) {
            var data = soundManager.soundSprite._soundById(soundManager.playingSounds[i]);
            if (data) {
                // Only monitor music
                var addItem = soundTracker.container.Props.musicOnly ? soundManager.soundsConfig.tags[data._sprite].isMusic : true;
                if (addItem) {
                    if (text !== "") text += "\n";
                    text += (data._sprite + " (" + soundManager.playingSounds[i] + ")");
                    soundsPlaying.push(data);
                }
            }
        }
        container.soundsText.setText(text);

        // Draw background
        var height = container.soundsText.height;
        var textHeight = height / soundsPlaying.length;
        var width = container.soundsText.width + textHeight;
        container.soundsText.position.setX(textHeight);
        container.background.clear();
        container.background.beginFill(0, 0.5);
        container.background.drawRect(0,0, width, height);
        container.background.endFill();

        // Draw volumes on left
        container.background.beginFill(0x0000FF, 0.5);
        for (var i = 0; i < soundsPlaying.length; i++) {
            var vol = soundsPlaying[i]._volume;
            container.background.drawRect(textHeight/4, textHeight*i + (textHeight-1)*(1-vol), textHeight/2, (textHeight-1)*vol);
        }
        container.background.endFill();

    }

    // Start tracking sounds
    Reflex.addToUpdate(container.update);
};


resourceManager.registerObjectType("soundTracker", function() { return new PIXI.Container(); }, soundTracker.initialise, function() {return []});